import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import { Function as SpaceFunction } from '../../../../../../../../space/function'
import * as _function from '../function'

export const RESOURCE = {
  payload: {
    modelId: _function.MODEL_ID,
    values: {
      [PartialId.Standard.create('active_periods')]: '{[,]}',
      [PartialId.Standard.create('code')]: SpaceFunction.Standard.Code.Vacant,
      [PartialId.Standard.create('descr')]: 'Space that is currently vacant.',
      [PartialId.Standard.create('id')]: SpaceFunction.Standard.Id.Vacant,
      [PartialId.Standard.create('is_exclusive')]: true,
      [PartialId.Standard.create('is_sponsored')]: false,
      [PartialId.Standard.create('name')]: 'Vacant',
    },
  },
  type: core.quiver.Resource.Type.DmsRecord,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsRecord>
